var render, staticRenderFns
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9ec7c",
  null
  
)

export default component.exports